import { useMutation } from '@tanstack/react-query';
import { registerInvitation } from '@/features/auth/services/invitation';
import type {
  RegisterInvitationRequest,
  RegisterInvitationResponse,
} from '@/features/auth/types/invitation.types';

interface UseRegisterInvitationOptions {
  onSuccess?: (data: RegisterInvitationResponse) => void;
  onError?: (error: Error) => void;
}

export function useRegisterInvitation(options?: UseRegisterInvitationOptions) {
  return useMutation<
    RegisterInvitationResponse,
    Error,
    RegisterInvitationRequest
  >({
    mutationFn: (payload) => registerInvitation(payload),
    onSuccess: (data) => {
      options?.onSuccess?.(data);
    },
    onError: (error) => {
      options?.onError?.(error);
    },
  });
}
